import logo1 from '@assets/images/footerLogos/logo1.png'
import logo2 from '@assets/images/footerLogos/logo2.png'

export const logosList = [
    {id: 1, image: logo1, height: '40px', link: 'https://translated.com', alt: 'Translated'},
    {id: 2, image: logo2, height: '50px', link: 'https://www.fbk.eu', alt: 'FBK'}
]
